export const getDefaultDebitCreditObj = (type = "debit") => ({
  id: null,
  caseSid: "",
  debitCreditNoteNumber: "",
  debitCreditLines: [],
  type,
  active: true,
  subTotal: 0,
});